import { render, staticRenderFns } from "./grade-info-double.vue?vue&type=template&id=24687d87&scoped=true&lang=pug"
import script from "./grade-info-double.vue?vue&type=script&lang=js"
export * from "./grade-info-double.vue?vue&type=script&lang=js"
import style0 from "./grade-info-double.vue?vue&type=style&index=0&id=24687d87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24687d87",
  null
  
)

export default component.exports